import {
  Component,
  OnInit,
} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {OrderBagService} from "../services/orderbag/orderbag.service";
import {TranslateService} from "ng2-translate";
import {DEFAULT_VIDEO_CALL_URL} from "../services/constants";

@Component({
  selector: 'video-meeting',
  template: require('./videoMeeting.component.html'),
  providers: [OrderBagService],
  styles: [require('./videoMeeting.component.css')]

})
export class VideoMeetingComponent implements OnInit {


  public order_detail;
  public displayMessage = '';
  public status;
  public id;
  public userShouldPay = false;
  public totalPrice;
  public isLoaded = false;
  public authorityCode;
  public refid;
  public clientrefid
  public statusstr = '-';
  public externalURL_fromWidget;
  public pageTitle:string= '';


  constructor(private activatedRoute: ActivatedRoute,
              private orderBagService: OrderBagService,
              private translate: TranslateService
  ) {

    translate.setDefaultLang('fa');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('fa');
  }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(params => {
      // console.log(params['reserveId']);
      this.getOrderBagDetail(+params['reserveId']);
    })
  }

  public getOrderBagDetail(id) {
    let parent = this;

    parent.orderBagService.getOrderBagDetailById(id).subscribe(detail => {
      parent.order_detail = detail;
      parent.order_detail.items.sort((val1, val2)=> {
        return <any>new Date(val1.timesession.startDate) - <any>new Date(val2.timesession.startDate);
      })
      if (detail.status == 0)
        this.isLoaded = false;

      this.setPageTitle();
    })
  }
  public setPageTitle() {
    let title = "رزرو" + " : " + this.order_detail.id + " - " + this.order_detail.serviceTitle;
    this.pageTitle = title;
  }

  public startVideoCall(item)
  {
    if(item.orderBagItemId)
    {
      // call service
      this.orderBagService.getVideoMeetingLinkByOrderBagItemId(item.orderBagItemId).subscribe(result => {

        if(result)
        {
          // go to url
          let link = DEFAULT_VIDEO_CALL_URL + result.link;
          window.open(link, "_blank");
        }

      })
    }

  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/video-meeting/videoMeeting.component.ts